export default __webpack_public_path__ + "static/media/staff_chevron_down.265fc86e.svg";